/*
 * @Autor: GeekMzy
 * @Date: 2023-12-08 20:43:08
 * @LastEditors: GeekMzy
 * @LastEditTime: 2023-12-08 20:43:08
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\api\videoCallApi.ts
 * @Author: geekm的电脑
 */
import { ApiGrid } from '@/service/api-grid'
import { CancelToken } from 'axios'

export class JsonResultCallInfoDto {
  code?: number
  data?: CallInfoDto
  msg?: string
}

export class JsonResultListWrjPathDto {
  code?: number
  data?: WrjPathDto[]
  msg?: string
}

export class CallInfoDto {
  /** 房间号 */
  channelNo?: string

  /** 状态 1表示请求通话   2表示通话中  3表示挂断 */
  status?: number

  /** 用户id */
  userId?: number
}

export class JsonResultString {
  code?: number
  data?: string
  msg?: string
}

export class WrjPathDto {
  /** 结束点经度 */
  endJd?: string

  /** 结束点纬度 */
  endWd?: string

  /** 飞行路径 */
  flightpath?: string

  /** id */
  id?: number

  /** 河流 */
  river?: string

  /** 开始点经度 */
  startJd?: string

  /** 开始点纬度 */
  startWd?: string
}

export class Api2<SecurityDataType = any> extends ApiGrid {
  openapi = {
    /**
     * No description
     *
     * @tags 开放接口
     * @name createUsingPOST_2
     * @summary 创建用户呼叫状态
     * @request POST:/openapi/call/create
     */
    createUsingPOST_2: (
      query?: { channelNo?: string; status?: number; userId?: number },
      cancelToken?: CancelToken | undefined
    ) => this.request<JsonResultString>(`/openapi/call/create`, 'POST', query, cancelToken),
    /**
     * No description
     *
     * @tags 开放接口
     * @name getChannelInfoUsingGET_1
     * @summary 获取用户状态
     * @request GET:/openapi/call/getChannelInfo
     */
    getChannelInfoUsingGET_1: (
      query: { wd?: string; zrrUserId?: number },
      cancelToken?: CancelToken | undefined
    ) =>
      this.request(
        `/openapi/call/getChannelInfo${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),
    /**
     * No description
     *
     * @tags 开放接口
     * @name getStatusUsingGET_2
     * @summary 根据房间号获取房间状态
     * @request GET:/openapi/call/getStatus
     */
    getStatusUsingGET_2: (query: { channelNo: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultCallInfoDto>(
        `/openapi/call/getStatus${this.addQueryParams(query)}`,
        'GET',
        null,
        cancelToken
      ),
    /**
     * No description
     *
     * @tags 开放接口
     * @name closeUsingPOST_2
     * @summary 挂断
     * @request POST:/openapi/call/close
     */
    closeUsingPOST_2: (
      query?: { channelNo?: string; status?: number; userId?: number },
      cancelToken?: CancelToken | undefined
    ) => this.request<JsonResultString>(`/openapi/call/close`, 'POST', query, cancelToken),
    /**
     * No description
     *
     * @tags 无人机巡河专题
     * @name getWrjFlyRecordUsingPOST_1
     * @summary 飞行记录
     * @request GET: /axyzt/wrjFlyRecord
     */
    getWrjFlyRecordUsingPOST_1: (query?: { ly?: string }, cancelToken?: CancelToken | undefined) =>
      this.request<JsonResultListWrjPathDto>(`/axyzt/wrjFlyRecord`, 'POST', query, cancelToken),
  }
}
